import React from 'react';
import { BaasicInput, BaasicConfirmModal, BaasicCheckbox } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { renderIf } from 'core/utils';
import _ from 'lodash';

const TableFilterTemplate = ({
	t,
	onClose,
	onClear,
	onApply,
	onSelect,
	onRemove,
	onSelectAll,
	position: { top, left, tableWrap, startLeftValue, startBottomValue, bottomCoordinate },
	form,
	loading,
	title,
	warningModal,
	columnFilter,
	focus,
	onTableFilterScroll,
	scrollContainerRef,
}) => {
	return (
		<div
			className={
				startLeftValue < tableWrap
					? startBottomValue > bottomCoordinate
						? 'table-filter arrow-down'
						: 'table-filter'
					: 'table-filter arrow-right'
			}
			style={{ top: top, left: left }}
		>
			<div className="row padd--bottom--sml">
				<div className="col col-sml-10">
					<h4 className="pull padd--top--tny">{t(title)}</h4>
				</div>
			</div>
			<button
				className="btn btn--med btn--ghost ReactModal__close react-filter-box-close"
				onClick={onClose}
				type="button"
			>
				<i className="fa fa-times"></i>
			</button>
			<div className="clearfix"></div>
			{renderIf(
				!form.$('search').value &&
					!title.includes('CREATEDBY') &&
					!title.includes('ONEPERBOX') &&
					!title.includes('ISSHIPPABLE') &&
					!title.includes('ISREPLACEMENT') &&
					!title.includes('COMPLETED') &&
					!title.includes('MULTIPACKAGED') &&
					!title.includes('ISPRIME') &&
					!title.includes('ISBUYSHIPPING') &&
					!title.includes('ISACTIVE') &&
					!title.includes('ISBUYERREQUESTEDCANCEL')
			)(<BaasicInput autoFocus={focus} field={form.$('freeType')} placeholder={t(form.$('freeType').placeholder)} />)}
			{renderIf(
				title != 'PRODUCTVIEW.DESCRIPTION' &&
					!form.$('freeType').value &&
					!title.includes('CREATEDBY') &&
					!title.includes('ONEPERBOX') &&
					!title.includes('ISSHIPPABLE') &&
					!title.includes('ISREPLACEMENT') &&
					!title.includes('COMPLETED') &&
					!title.includes('MULTIPACKAGED') &&
					!title.includes('ISPRIME') &&
					!title.includes('ISBUYSHIPPING') &&
					!title.includes('ISACTIVE') &&
					!title.includes('ISBUYERREQUESTEDCANCEL')
			)(<BaasicInput autoComplete={'off'} field={form.$('search')} />)}
			{renderIf(title != 'PRODUCTVIEW.DESCRIPTION' && !form.$('freeType').value)(
				<div className="table-filter__list spc--top--tny" ref={scrollContainerRef} onScroll={onTableFilterScroll}>
					{loading ? (
						<button className="btn btn--med btn--primary align--h--center" disabled={true}>
							<div className="spinnercont">
								<div className="spinner"></div>
							</div>
							{t('LOADING')}
						</button>
					) : (
						_.map(form.$('searchList').value, (item, idx) => {
							let checkBoxRef = React.createRef();
							let checked;
							let valueToUse;
							if (title.includes('CREATEDBY')) {
								valueToUse = item.name;
								checked = _.some(form.$('selectedList').value, selectedItem => selectedItem === item.id) ? true : false;
							} else {
								valueToUse = item;
								checked = _.some(
									form.$('selectedList').value,
									selectedItem =>
										selectedItem === (valueToUse === t('YES') ? true : valueToUse === t('NO') ? false : valueToUse)
								)
									? true
									: false;
							}
							return (
								<div key={encodeURIComponent(valueToUse) + idx}>
									<input
										id={'ID_' + encodeURIComponent(valueToUse) + idx}
										className="input--check"
										type="checkbox"
										ref={checkBoxRef}
										onChange={evt => {
											return onSelect({
												item,
												form,
												evt,
											});
										}}
										checked={checked}
										data-cy={`search-list-${idx}-${valueToUse.toLowerCase().replace(/\s/g, '-')}`}
									/>
									<label htmlFor={'ID_' + encodeURIComponent(valueToUse) + idx} className="no_selection">
										{valueToUse}
									</label>
								</div>
							);
						})
					)}
				</div>
			)}
			<div className="separator--primary spc--bottom--xsml spc--top--xsml"></div>
			<div className="clearfix spc--bottom--sml">
				<BaasicCheckbox
					id={form.$('selectAll').id}
					label={'FILTER.SELECTALL'}
					checked={
						form.$('selectedList').value.length > 0 &&
						form.$('selectedList').value.length == form.$('searchList').value.length
					}
					onChangeCallback={event => onSelectAll(event)}
				></BaasicCheckbox>
				<button
					disabled={
						(form.$('selectedList').value == undefined || form.$('selectedList').value.length == 0) &&
						form.$('freeType').value == ''
					}
					className="btn btn--med btn--tertiary table-filter__fullwidth"
					onClick={onApply}
					data-cy="apply-filter"
				>
					{t('FILTER.APPLY')}
				</button>
			</div>
			<button
				disabled={!columnFilter}
				className="btn btn--med btn--secondary pull"
				onClick={onRemove}
				data-cy="remove-filter"
			>
				{t('FILTER.REMOVE')}
			</button>
			<button
				disabled={
					(form.$('selectedList').value == undefined || form.$('selectedList').value.length == 0) &&
					form.$('freeType').value == '' &&
					form.$('search').value == ''
				}
				className="btn btn--med btn--primary push"
				onClick={onClear}
				data-cy="reset-filter"
			>
				{t('FILTER.CLEAR')}
			</button>
			<div className="clearfix"></div>
			<BaasicConfirmModal modalParams={warningModal} />
		</div>
	);
};

export default defaultTemplate(TableFilterTemplate);
